/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Spellcheck_Engine_LocalInputs */



/**
* | output |
* | --- |
* | "Local" |
*
* @param {Spellcheck_Engine_LocalInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const spellcheck_engine_local = /** @type {((inputs?: Spellcheck_Engine_LocalInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Spellcheck_Engine_LocalInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Local")
	if (locale === "de") return /** @type {LocalizedString} */ ("Lokal")
	if (locale === "it") return /** @type {LocalizedString} */ ("Locale")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Местный")
	if (locale === "es") return /** @type {LocalizedString} */ ("Local")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("当地的")
	if (locale === "ja") return /** @type {LocalizedString} */ ("地元")
	if (locale === "hi") return /** @type {LocalizedString} */ ("स्थानीय")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Local")
	return /** @type {LocalizedString} */ ("Local")
});